import { ViewCoreBase } from "./view.core.base"


export class ViewCore extends ViewCoreBase {

}